import {Alpine as IAlpine} from 'alpinejs';
import LazyLoad from 'vanilla-lazyload';

// Single instance shared across the page, exported so code outside of Alpine's `x-data` scope (which is
// the only place the `$lazyLoad` magic property is reachable) can also call `.update()` for markup
// injected after the initial page load - e.g. the `consent-video` plugin, once EXT:a11y_consent decodes
// a gated YouTube embed into the DOM.
export const lazyLoad = new LazyLoad({
  threshold: 0,
  elements_selector: '[lazy]',
  class_loading: 'lazy-loading',
  class_loaded: 'lazy-loaded',
  class_applied: 'lazy-bg-loaded',
  class_error: 'lazy-error'
});

export default function (Alpine: IAlpine) {
  Alpine.magic('lazyLoad', () => lazyLoad);

  document.documentElement.addEventListener('ajax:after', () => {
    lazyLoad.update();
  });
}
